import { Navigate } from "react-router-dom";
import { useAccess } from "../../utils/hooks/access";

function Redirect() {
    const { hasAccess, authenticating } = useAccess("canManageUsers");

    if (authenticating) {
        return null;
    }

    if (hasAccess) {
        const to = "/scheduler/team";
        return <Navigate to={to} replace />;
    }
    const to = "/scheduler/my";
    return <Navigate to={to} replace />;
}

export default Redirect;
